import React from 'react';
import { Button } from './ui/button';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen w-full flex flex-col items-center justify-center overflow-hidden pt-24">
      {/* Blue Premium Background */}
      <div className="absolute inset-0 premium-blue">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)`,
            backgroundSize: '50px 50px'
          }}></div>
        </div>
        <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-[#FFFFFF]/10 blur-[120px] pointer-events-none"></div>
        <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] rounded-full bg-[#7B9BC0]/20 blur-[140px] pointer-events-none"></div>
      </div>
      
      {/* Triptych Banner - full width, edge to edge */}
      <div className="relative w-full px-0 mb-12 animate-fade-in">
        <div className="flex items-stretch justify-center w-full h-52 sm:h-64 md:h-80 lg:h-[26rem] overflow-hidden shadow-[0_25px_60px_-10px_rgba(0,0,0,0.6),0_-15px_40px_-10px_rgba(0,0,0,0.4)] ring-1 ring-black/20">
          {/* Left photo */}
          <div
            className="block flex-1"
            style={{
              backgroundImage: "url(https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/w1iq6psu_ChatGPT%20Image%205%20mai%202026%2C%2011_45_37.png)",
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>

          {/* Center logo - square, same height as photos */}
          <img
            src="https://customer-assets-gfyr7b9c.emergentagent.net/job_bureaux-prestige/artifacts/afi6ebzy_Logo%20ESPRIT%20OUEST.png"
            alt="Esprit Ouest - Centres d'affaires Versailles, Jouy-en-Josas, Viroflay"
            className="h-full w-auto object-cover"
          />

          {/* Right photo */}
          <div
            className="block flex-1"
            style={{
              backgroundImage: "url(https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/vblvtwuk_ChatGPT%20Image%205%20mai%202026%2C%2017_49_57.png)",
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>
        </div>
      </div>

      {/* Content - centered text below banner */}
      <div className="relative w-full max-w-6xl mx-auto px-4 md:px-6 pb-24 md:pb-32 text-center">

        {/* Subtitle */}
        <p className="text-sm sm:text-base md:text-2xl text-gray-200 mb-10 md:mb-12 max-w-3xl mx-auto leading-relaxed font-light animate-fade-in break-words" style={{ animationDelay: '0.4s' }}>
          Bureaux privatifs dès 400 €/mois tout compris et espaces de réunion design,<br className="hidden md:block" />
          où raffinement et professionnalisme se rencontrent
        </p>

        {/* Locations */}
        <div className="text-xs sm:text-sm md:text-base text-white font-bold mb-10 md:mb-12 uppercase tracking-widest animate-fade-in" style={{ animationDelay: '0.6s' }}>
          Versailles • Jouy-en-Josas • Viroflay • Le Neubourg
        </div>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16 animate-fade-in" style={{ animationDelay: '0.8s' }}>
          <Button
            onClick={() => scrollToSection('contact')}
            className="bg-white hover:bg-[#E5E7EB] text-[#4A6B96] font-bold text-base px-10 py-6 rounded-none border-2 border-white transition-all duration-300">

            Réserver une visite
          </Button>
          <Button
            onClick={() => scrollToSection('espaces')}
            variant="outline"
            className="border-2 border-[#FEFEFE] text-[#FEFEFE] hover:bg-[#F8F8F5] hover:text-[#4A6B96] font-bold text-base px-10 py-6 rounded-none transition-all duration-300">

            Découvrir
          </Button>
        </div>

        {/* Stats - Minimal */}
        <div className="flex justify-center gap-6 sm:gap-10 md:gap-16 text-center animate-fade-in" style={{ animationDelay: '1s' }}>
          <div>
            <div className="text-3xl md:text-4xl text-white font-bold mb-1">4</div>
            <div className="text-xs text-gray-300 uppercase tracking-wider">Sites</div>
          </div>
          <div className="border-l border-gray-400/40"></div>
          <div>
            <div className="text-3xl md:text-4xl text-white font-bold mb-1">20+</div>
            <div className="text-xs text-gray-300 uppercase tracking-wider">Bureaux</div>
          </div>
          <div className="border-l border-gray-400/40"></div>
          <div>
            <div className="text-3xl md:text-4xl text-white font-bold mb-1">40+</div>
            <div className="text-xs text-gray-300 uppercase tracking-wider">Clients</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-white" size={32} strokeWidth={1.5} />
      </div>
    </section>);

};

export default Hero;